import Vue from 'vue';

const GridResize = Vue.extend({
    data: () => ({
        gridHeight: 500,
        gridHeightAdjustment: 310,
    }),
    methods: {
        resizeGrid(): void {
            const defaultHeight = 500 + this.gridHeightAdjustment;
            this.gridHeight = (this.$parent?.$el?.clientHeight ?? defaultHeight) - this.gridHeightAdjustment;
        },
    }
});

export default GridResize;
